import { get } from 'common/network';
import { makeObservable, observable, action } from 'mobx';
import ArchiveItemViewModel from 'pages/archive/viewModels/archiveItemViewModel';
import { IStore } from './index';

export class ArchiveStore {
  constructor(private rootStore: IStore) {
    makeObservable(this);
  }

  @observable catalogs = new Array<ArchiveItemViewModel>();
  @observable isLoading = new Map<number, boolean>();

  public get_archive(): ArchiveItemViewModel[] | undefined {
    if (this.catalogs.length === 0) {
      this.fetchPage(0);
      return undefined;
    }

    return this.catalogs;
  }

  @action async fetchPage(page: number) {
    if (this.isLoading.get(page)) {
      return;
    }

    this.isLoading.set(page, true);

    const url = `auctions/archive?pageSize=7&page=${page + 1}`;

    const result = await get<any[]>(undefined, url, false);

    const objects = result.map((a: any) => new ArchiveItemViewModel(a));

    this.catalogs = objects;

    this.isLoading.set(page, false);
  }
}
